import { fontSizes } from "../../constants/constants";
import Icons from "../../assets/icon/index";
import { FormInput, Authslide, Newlogo, Button, Text } from "../../components";
import Functions from "./index.function";
const Login = () => {
  const {
    TextWeight,
    handleSubmit,
    onSubmit,
    control,
    emailData,
    errors,
    loading,
    navigate,
  } = Functions();

  return (
    <div className="bg-primary scroll-container h-screen">
      <div className="my-5 sm:my-7 lg:my-10 w-full flex justify-center items-center">
        <Newlogo />
      </div>
      <Authslide />
      <div className="max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        {/* <div className="flex text-center sm:items-center lg:py-8"> */}
        <Text
          text={
            <>
              Welcome Back,{" "}
              <Text
                className="bg-goldMetallic rounded-full px-1 sm:px-2 inline"
                weight={TextWeight.Unbounded_bold}
                text="GEM"
                isCenter={true}
                isTruncate={false}
              />
            </>
          }
          size={fontSizes.h30}
          weight={TextWeight.Unbounded_bold}
          color="text-secondary"
          isCenter={true}
          isTruncate={false}
        />
        {/* <Text
                        text={'Continue with Google or enter your details'}
                        size={fontSizes.h16}
                        weight={TextWeight.Montserrat_medium}
                        color='text-secondary'
                        className={"lg:pt-5"}
                    /> */}
        {/* </div> */}
        <form
          className="flex justify-center items-center flex-col"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="relative mt-[18px] sm:w-[85%] xs:w-full lg:w-[70%]">
            <FormInput
              label={"Username"} 
              control={control}
              userData={emailData}
              name="username" 
              type="text" 
              placeholder="Username"
              isMandatory={true}
              isRequired={true}
              pattern={{
                value: /^(?:\d{10,15}|[\w-\.]+@([\w-]+\.)+[\w-]{2,4})$/,
                message: "Enter a valid phone number or email address",
              }}
              errors={errors}
            />
          </div>
          <div className="relative mt-4 sm:w-[85%] xs:w-full lg:w-[70%]">
            <FormInput
              control={control}
              userData={""}
              label="Password"
              type="password"
              name="password"
              placeholder="Password"
              isPassword={true}
              isMandatory={true}
              isRequired={true}
              iconPasswordVisible={Icons.showPasswordIcon}
              iconPasswordHidden={Icons.hidePasswordIcon}
              iconStyle={"xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-6 w-7 3xl:w-8 3xl:h-7"}
              // maxLength={30}
              is_ForgotPassword={true}
              pattern={{
                value: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
                // message:
                //   "Password must be at least 8 characters long, contain at least 1 uppercase letter and 1 number",
              }}
              errors={errors}
            />
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] pl-6 sm:pl-6 lg:pl-8"
            }
          >
            <Text
              text="Password must be at least 8 characters long, contain at least 1 uppercase letter and 1 number"
              size={fontSizes.h14}
              color="text-secondary"
              align="text-left"
              weight={TextWeight.Onest_regular}
              isTruncate={false}
            />
          </div>
          <Button
            text="Log In"
            type={"submit"}
            bgColor="gradient-container_btn"
            color="text-secondary"
            className="xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 lg:h-12 my-10 lg:my-8"
            textSize={fontSizes.h16}
            weight={TextWeight.Onest_semiBold}
            loading={loading}
            isDisabled={loading}
          />
        </form>

        <Text
          text={
            <>
              <span>Don't have an account?&nbsp;</span>
              <Text
                text="Register"
                onClick={() => navigate("/register")}
                className="text-secondary cursor-pointer hover:text-strong_Cyan hover:underline"
              />
            </>
          }
          size={fontSizes.h14}
          weight={TextWeight.Onest_regular}
          color="text-secondary"
          className={"flex justify-center items-center pb-5"}
        />
        {/* <Text
          text="Sign in with google"
          className="flex justify-center w-fit mx-auto items-center xs:pt-2 sm:pt-2 sm:pb-4 lg:pt-3 gap-2 xs:pb-5 lg:pb-5 text-secondary cursor-pointer hover:underline"
          icon={Icons.googleIcon}
          size={fontSizes.h14}
          weight={TextWeight.Onest_medium}
        /> */}
      </div>
    </div>
  );
};
export default Login;
